import React, { useEffect, useState } from 'react'


import { loadDegreeReport, loadDegrees, loadPeopleDegrees } from '../utils/Network'
import { buildReports, getDefaultName, userAvatar } from '../utils';
import SelectJuries from '../components/SelectJuries';
import SelectGender from '../components/SelectGender';
import DegreeProgress from '../components/DegreeProgress';
import AvgProgress from '../components/AvgProgress';
import CourseDocumentPublicButton from '../components/CourseDocumentPublicButton';
import Modal from 'react-modal';
import UrlEmbed from '../components/UrlEmbed';
import ModalDegreeProgress from '../components/ModalDegreeProgress';
import SelectSize from '../components/SelectSize';
import SelectCountries from "../components/SelectCountries";
import SelectCities from '../components/SelectCities';
import ModalPeopleDegreeProgress from '../components/ModalPeopleDegreeProgress';
import BreadCrumbs from '../components/shared/BreadCrumbs';
import SelectCourses from '../components/SelectCourses';


export default function RatingsContent({ urlParams }) {

    const [pageloading, setPageLoading] = useState(false);
    const [reports, setReports] = useState(null);
    const [filter_talent, setFilterTalent] = useState(null);
    const [filter_jury, setFilterJury] = useState(null);
    const [filter_course, setFilterCourse] = useState(null);
    const [filter_size, setFilterSize] = useState(1000);
    const [filter_gender, setFilterGender] = useState(null);
    const [filter_country, setFilterCountry] = useState(null);
    const [filter_city, setFilterCity] = useState(null);
    const [current_document, setCurrentDocument] = useState(null);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modal_degrees, setModalDegrees] = useState(false);

    const [peopleModalIsOpen, setPeopleModalIsOpen] = useState(false);
    const [modal_people_degrees, setModalPeopleDegrees] = useState(false);
    const [people_degree_count, setPeopleDegreeCount] = useState(false);


    useEffect(() => {
        var filter_query = window.location.search;
        _getData(filter_query);
        
        setFilterTalent(urlParams.get('talent'));
        setFilterJury(urlParams.get('jury') || urlParams.get('referee'));
        setFilterCourse(urlParams.get('course'));
        setFilterGender(urlParams.get('gender'));
    }, []);

    const _getData = (filter_query) => {

        setPageLoading(true)
        loadDegreeReport(filter_query).then(data => {
            let reps = buildReports(data)
            setReports(reps)
            setPageLoading(false)
        })
    }

    const openModal = (current_document, courseparticipant) => {
        loadDegrees(courseparticipant.id).then(degrees => {
            setModalDegrees(degrees)
        })

        setCurrentDocument(current_document)
        setModalIsOpen(true)
    }

    const openPeopleDegreeModal = (course, usertalent) => {
        setPeopleDegreeCount("-")
        // setPeopleModalTitle(usertalent.user.profile)
        setModalPeopleDegrees(null)

        loadPeopleDegrees(course.id, usertalent.id).then(data => {
            if (data?.count)
                setPeopleDegreeCount(data.count)
            var page_count = parseInt(data.count / 10) + 1;
            // var pages_array = page_count>0 ? range(1, page_count) : [];
            // setPages(pages_array);
            // setNext(data.next);
            // setPrevious(data.previous);

            if (data.results)
                setModalPeopleDegrees(data.results)
        })

        setPeopleModalIsOpen(true)
    }

    const closePeopleDegreeModal = () => {
        setPeopleModalIsOpen(false)
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }

    /** Updates query string in the address bar and refetches; keeps existing params (e.g. course) when changing one filter. */
    const syncRatingsQueryAndFetch = (partial) => {
        const p = new URLSearchParams(window.location.search);
        const setOrDelete = (key, val) => {
            if (val === null || val === undefined || val === '' || val === 0) {
                p.delete(key);
            } else {
                p.set(key, String(val));
            }
        };
        if ('course' in partial) {
            setOrDelete('course', partial.course);
        }
        if ('referee' in partial) {
            setOrDelete('referee', partial.referee);
            p.delete('jury');
        }
        if ('gender' in partial) {
            setOrDelete('gender', partial.gender);
        }
        if ('size' in partial) {
            setOrDelete('size', partial.size);
        }
        const qs = p.toString();
        const q = qs ? `?${qs}` : '?';
        window.history.replaceState(null, '', `${window.location.pathname}${qs ? `?${qs}` : ''}`);
        _getData(q);
    };

    const onValue = (value, name) => {
        // alert(name)
        switch (name) {
            case "course":
                setFilterCourse(value);
                syncRatingsQueryAndFetch({ course: value });
                break;
            case "talent":
                setFilterTalent(value)
                break;
            case "jury":
                setFilterJury(value)
                syncRatingsQueryAndFetch({ referee: value });
                break;
            case "gender":
                setFilterGender(value)
                break;
            case "size":
                setFilterSize(value)
                break;
            case "country":
                setFilterCountry(value)
                break;
            case "city":
                setFilterCity(value)
                break;

            default:
                break;
        }
    }

    function BadgeClass(value) {

        if (value < 30) {

            return "badge bg-red mr-10";
        }
        else if (value < 50) {
            return "badge bg-yellow mr-10";
        }
        else if (value < 70) {
            return "badge bg-light-blue mr-10";
        }
        else if (value <= 100) {
            return "badge bg-green mr-10";
        }


    }

    let t_index = 0;


    function FilterRatings() {
        return (
            <div className="box-header bg-gray cms-ratings-filter">
                <form action="">
                    <div class="box-tools pull-right">
                        <button type="submit" className="btn btn-cm pull-right mt-2p mr-1 "><i className="fa fa-search"></i></button>
                    </div>
                    <div className="filter-container">
                        {/* <div className="mb-5 mr-5">
                                                <SelectTalent width={"230px"} value={filter_talent} callback={onValue} />
                                                <input type="hidden" name="talent" value={filter_talent} />

                                            </div> */}
                        <div className=" mb-5 ">
                            <SelectJuries width={"150px"} value={filter_jury} callback={onValue} />
                            <input type="hidden" name="jury" value={filter_jury} />
                        </div>
                        <div className=" mb-5 ">
                            <SelectCourses width={"150px"} value={filter_course} callback={onValue} />
                            <input type="hidden" name="course" value={filter_course} />
                        </div>
                        <div className=" mb-5 ">
                            <SelectGender width={"120px"} value={filter_gender} callback={onValue} />
                            <input type="hidden" name="gender" value={filter_gender} />

                        </div>
                        <div className=" mb-5 ">
                            <SelectCountries kurds={1} value={filter_country} name="country" width="120px" border="1" callback={onValue} />
                            <input type="hidden" name="gender" value={filter_country} />

                        </div>
                        <div className=" mb-5 ">
                            <SelectCities country={filter_country} key={filter_country} value={filter_city} name="city" width="120px" border="1" callback={onValue} />
                            <input type="hidden" name="gender" value={filter_city} />

                        </div>
                        <div className=" mb-5 ">
                            <SelectSize width={"100px"} value={filter_size} callback={onValue} />
                            <input type="hidden" name="size" value={filter_size} />
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    function DegreeItem({ item, index }) {

        if (t_index >= filter_size) return;

        //console.log(item[0].questions)
        let usertalent = item[0].courseparticipant.usertalent;
        let courseparticipant = item[0].courseparticipant;
        let course = item[0].courseparticipant.course;
        let coursedocument = item[0].coursedocument;
        let user = usertalent.user;
        let profile = user.profile;

        if (filter_gender != null && filter_gender !== profile.gender) {
            return;
        }

        if (filter_country != null && filter_country !== profile.country) {
            return;
        }


        if (filter_city != null && filter_city !== profile.city?.id) {
            return;
        }

        t_index++;

        let questions = item[0].questions;

        let people_degree = item[0].peopledegree_average.degree__avg

        return (
            <li key={item.id} className="degree-item cms-ratings-card">
                <div className="talent" onClick={() => { openModal(coursedocument.userdocument, courseparticipant) }}>
                    <span style={{ fontSize: 11 }}>{getDefaultName(usertalent.talent.names)}</span>
                    <br />
                    <i className="fa fa-play "></i>
                </div>
                <div className={`index ${index < 10 ? "gold-box" : index < 30 ? "blue-box" : ""}`}>
                    {t_index}
                </div>
                <div className="coursedocument">
                    <CourseDocumentPublicButton coursedocument={coursedocument} />
                </div>
                <div class="widget-user-header  text-center">
                    <div class="widget-user-image">
                        <a href={`/cms/usertalent/${profile.id}`} >
                            <img class="img-circle img-rating" title={profile.first_name + " " + profile.last_name} alt={profile.first_name + " " + profile.last_name}
                                src={profile.avatar ? userAvatar(profile) : profile.gender == "1" ? "assets/dist/img/avatar-f.jpeg" : "assets/dist/img/avatar-m.jpeg"} />
                        </a>
                    </div>

                </div>
                <table class="table table-degrees  ">
                    <tbody>
                        {
                            questions && questions.map(question_item => {
                                return (
                                    <DegreeProgress question_item={question_item} />

                                )
                            }
                            )}

                        <tr className="bg-audience" >
                            <th style={{ fontSize: "11px", width: 200, paddingLeft: 20 }} >Audience</th>
                            <th ></th>
                        </tr>
                        <AvgProgress avg={people_degree} onClick={() => {
                            openPeopleDegreeModal(course, usertalent)
                        }} />
                        <tr className="pointer" onClick={() => {
                            openModal(coursedocument.userdocument, courseparticipant)
                        }}>
                            <td style={{ width: 180, paddingLeft: 20, }}>
                                <div class="">
                                    Total
                                </div>
                            </td>
                            <td><span class={BadgeClass(item.total)}>
                                {
                                    item.total
                                }

                            </span></td>
                        </tr>
                    </tbody>
                </table>

            </li>
        )
    }


    return (
        <>
            <div className="content-wrapper cms-ratings-surface">
                <BreadCrumbs title="Ratings" />
                <section className="content padding-top-sm-0">

                    <div class="row">

                        <div class="col-md-12">
                            <div class="box box-primary">
                                {pageloading && (
                                    <>
                                        <div className="overlay">
                                            <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                                        </div>
                                    </>
                                )}
                                <div class="box-header with-border">
                                    <h3 class="box-title mt-5">Ratings</h3>
                                    <button type="button" className="btn btn-cm pull-right mt-2p "><i className="fa fa-list"></i></button>
                                </div>
                                <FilterRatings />
                                <div class="box-body no-padding">
                                    <div className="table-responsive mailbox-messages padding-10 cms-ratings-grid-wrap">
                                        <ul className="mailbox-attachments rating-documents cms-ratings-grid clearfix">
                                            {reports && reports.map((item, index) =>
                                                <DegreeItem item={item} index={index} />
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </section>
            </div>
            <Modal
                closeTimeoutMS={500}
                isOpen={peopleModalIsOpen}
                ariaHideApp={false}
                onRequestClose={closePeopleDegreeModal}
                className="Modal "
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closePeopleDegreeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title">People Degree ({people_degree_count})</h4>
                    </div>
                    <div class="modal-body height-500 overflow-auto">
                        <div className="row">
                            <div className="col-md-12">
                                <table class="table table-degrees  ">
                                    <tbody>
                                        {modal_people_degrees && modal_people_degrees.map((degree, index) => (
                                            <ModalPeopleDegreeProgress
                                                index={index} degree_item={degree} />
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </div>

                </div>
            </Modal>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                ariaHideApp={false}
                onRequestClose={closeModal}
                className="Modal modal-lg"
                overlayClassName="Overlay"
            >
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 class="modal-title"> </h4>
                    </div>
                    <div class="modal-body text-center">
                        <div className="row">
                            <div className="col-md-8">
                                {current_document &&
                                    current_document.url &&
                                    current_document.url !== "undefined" && (
                                        <UrlEmbed height="400" url={current_document.url} />
                                    )}
                            </div>
                            <div className="col-md-4">
                                <table class="table table-degrees  ">
                                    <tbody>
                                        {modal_degrees && modal_degrees.map((degree, index) => (
                                            <ModalDegreeProgress index={index} degree_item={degree} />
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal>
        </>



    )
}
